<div class="tab-section">
  <ul class="nav nav-tabs custom-tab-header" role="tablist">
    @for (tab of tabs; track tab; let i = $index; let isFirst = $first; let isLast = $last) {
      <li
        role="tab"
        class="nav-item custom-tab-list"
        [attr.aria-selected]="tab.active"
        >
        <span
          [matTooltip]="getDisabledTabTooltip(i)"
          matTooltipPosition="above"
          >
          <button
            class="custom-tab-label"
            [class.active]="tab.active"
            (click)="selectTab(i)"
            type="button"
            [disabled]="disabled || disabledIndexList?.includes(i)"
            [ngClass]="{ 'custom-tab-label-active': selectedTab === i, 'first-tab': isFirst, 'last-tab': isLast }"
            >
            {{ tab.label }}
          </button></span>
        </li>
      }
    </ul>
    <div class="tab-content" role="tabpanel">
      @for (tab of tabsArray; track tab; let i = $index) {
        @if (selectedTab === i && tab.template) {
          <div>
            <ng-container [ngTemplateOutlet]="tab.template"></ng-container>
          </div>
        }
        @if (selectedTab === i && !tab.template) {
          <div>
            <ng-content></ng-content>
          </div>
        }
      }
    </div>
  </div>
